import { BaseEntity } from "../baseEntity";

export class CMSCollection extends BaseEntity {
  declare name: string;
  description: string;
  enabled: string;

  type: string;
  assets: string[];
  channels: string[];

  declare createdAt: string;
  declare updatedAt: string;

  constructor() {
    super();
    this.type = "default";
  }

  serialize() {
    return {
      _id: this._id,
      name: this.name,
      description: this.description,
      enabled: this.enabled,
      type: this.type,
      createdAt: this.createdAt,
      updatedAt: this.updatedAt,
      assets: this.assets,
      channels: this.channels,
    };
  }
}
